import { StatsigClient, StatsigClientEvent } from '@statsig/react-bindings'

export class StatsigClarityTracking {
  private client: StatsigClient

  constructor(client: StatsigClient) {
    this.client = client
  }

  private setClarityAttribute = (
    key: string,
    value: string | null | undefined,
  ) => {
    if (value) {
      window?.clarity?.('set', key, value)
    }
  }

  private handleGateEvaluation = (
    event: StatsigClientEvent<'gate_evaluation'>,
  ) => {
    try {
      const {
        gate: { name, value },
      } = event

      if (value) {
        this.setClarityAttribute('statsig_feature_gate', name)
      }
    } catch (error) {
      console.error('Error setting statsig_feature_gate', error)
    }
  }

  private handleExperimentEvaluation = (
    event: StatsigClientEvent<'experiment_evaluation'>,
  ) => {
    try {
      const {
        experiment: { __evaluation, name, groupName },
      } = event

      const isUserInExperiment = __evaluation?.is_user_in_experiment

      if (groupName && isUserInExperiment) {
        this.setClarityAttribute('statsig_experiment', name)
        this.setClarityAttribute('statsig_experiment_group_name', groupName)
      }
    } catch (error) {
      console.error('Error setting statsig_experiment', error)
    }
  }

  private setUserContext = () => {
    const { stableID, user } = this.client.getContext()
    const userType = user.userID ? 'userID' : 'stableID'
    const statsigID = userType === 'userID' ? user.userID : stableID

    this.setClarityAttribute('statsig_id', statsigID)
    this.setClarityAttribute('statsig_id_type', userType)
  }

  private eventHandler = (
    event: StatsigClientEvent<'gate_evaluation' | 'experiment_evaluation'>,
  ) => {
    if (typeof window === 'undefined') return

    this.setUserContext()

    switch (event.name) {
      case 'gate_evaluation':
        this.handleGateEvaluation(
          event as StatsigClientEvent<'gate_evaluation'>,
        )
        break
      case 'experiment_evaluation':
        this.handleExperimentEvaluation(
          event as StatsigClientEvent<'experiment_evaluation'>,
        )
        break
    }
  }

  public startTracking = () => {
    this.client.on('gate_evaluation', this.eventHandler)
    this.client.on('experiment_evaluation', this.eventHandler)
  }

  public stopTracking = () => {
    this.client.off('gate_evaluation', this.eventHandler)
    this.client.off('experiment_evaluation', this.eventHandler)
  }
}
